import React from 'react';

const StoreOverallsGarmentsIndex = React.lazy(() => import("./index"))
const NewStoreOverallsGarments = React.lazy(() => import("./new"))
const EditStoreOverallsGarments = React.lazy(() => import("./edit"))

export default[
	{path:'/store/overalls/garments/:id/edit',component: EditStoreOverallsGarments,name:'Edit StoreOverallsGarment'},
	{path:'/store/overalls/garments/new',component: NewStoreOverallsGarments,name:'New StoreOverallsGarment'},  
	{path:'/store/overalls/garments',component: StoreOverallsGarmentsIndex,name:'StoreOverallsGarments'}, 
]

// import StoreOverallsGarmentsRoutes from "modules/store/overalls/garments/web/routes"
// routes = _.concat(routes,StoreOverallsGarmentsRoutes)
